import { Button, Dialog, DialogContent, DialogFooter, DialogHeader } from '@bi-digital/react';
import { useTranslation } from 'react-i18next';
import { getSignInUrl } from '../../api';
import { useCartContext } from '../../context/CartContext';
import useRedirectLoading from '../../hooks/useRedirectLoading';
import styles from './GlobalCartError.module.css';

export default function GlobalCartError() {
    const { globalCartError } = useCartContext();
    const { redirectLoading, startRedirectLoading } = useRedirectLoading();
    const { t } = useTranslation(['cart', 'common']);

    const login = async () => {
        startRedirectLoading();
        window.location.href = getSignInUrl();
    };

    if (!globalCartError) {
        return null;
    }

    return (
        <Dialog open={!!globalCartError} closedby='closerequest'>
            <DialogHeader noBorder>{t('cart:errorDuringSignInTitle')}</DialogHeader>
            <DialogContent noBorder className={styles.dialogContent}>
                {t('cart:errorDuringSignInBody')}
            </DialogContent>
            <DialogFooter noBorder>
                <Button variant='text' asChild>
                    <a href='/api/cart/logout'>{t('common:cancel')}</a>
                </Button>
                <Button submitting={redirectLoading} onClick={login}>
                    {t('cart:loginAgain')}
                </Button>
            </DialogFooter>
        </Dialog>
    );
}
